import { render } from "./NavbarTemp.vue?vue&type=template&id=7ffc8140&scoped=true"
import script from "./NavbarTemp.vue?vue&type=script&lang=js"
export * from "./NavbarTemp.vue?vue&type=script&lang=js"

import "./NavbarTemp.vue?vue&type=style&index=0&id=7ffc8140&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ffc8140"]])

export default __exports__